import request from 'utils/request'

/**
 * 1. 以下接口在系统设置模块下多个页面都会用到
 * 2. add 和 getTableData接口 中type这个key会区分相关设置和查询，参数具体值在使用接口处传递
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
// 添加或者编辑
export const add = data => request().post('business/add', data)

// 删除
export const remove = id => request().get(`business/delete/${id}`)

// 获取业务类型select数据
export const getBusinessTypeList = () => request().get('business/list')

// 获取表格数据
export const getTableData = data => request().post('business/region/page', data)

//信用限额审批规则
export const getRules = id => request().get(`business/rules/${id}`)

// 冻结
export const freeze = id => request().get(`business/freeze/${id}`)

// 解冻
export const thaw = id => request().get(`business/thaw/${id}`)

// 获取业务类型列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')
